import { format, parseISO, subDays } from 'date-fns';

interface DateRange {
  start: Date;
  end: Date;
  endInclusive: boolean;
}

/**
 * Parse a PostgreSQL daterange string like "[2024-01-01,2025-01-01)"
 */
function parseDateRange(raw: string): DateRange | null {
  const match = raw.match(/^([[\(])(\d{4}-\d{2}-\d{2}),(\d{4}-\d{2}-\d{2})([\])])$/);
  if (!match) return null;
  return {
    start: parseISO(match[2]),
    end: parseISO(match[3]),
    endInclusive: match[4] === ']',
  };
}

/**
 * Format a PostgreSQL daterange for display.
 * Adjusts exclusive end dates by subtracting one day
 * (PostgreSQL convention: [start, end) means end is the day AFTER the last valid day).
 */
export function formatDateRange(raw: string | null): string {
  if (!raw) return '\u2014';
  const range = parseDateRange(raw);
  if (!range) return '\u2014';
  const displayEnd = range.endInclusive ? range.end : subDays(range.end, 1);
  return `${format(range.start, 'MMM d, yyyy')} \u2013 ${format(displayEnd, 'MMM d, yyyy')}`;
}
